import { registerApplication, start, addErrorHandler } from 'single-spa';
import { constructApplications, constructRoutes, constructLayoutEngine } from 'single-spa-layout';

import { mfFallbackHandler, isAuthDomain } from './utils';
import './styles/global-styles.css';

const isSignupAllowed = !isAuthDomain();

const routes = constructRoutes({
    routes: [
        {
            type: 'header',
            routes: [{ type: 'application', name: '@sso/header' }],
        },
        {
            type: 'main',
            routes: [
                ...(isSignupAllowed
                    ? [
                          {
                              type: 'route',
                              path: 'signup',
                              routes: [{ type: 'application', name: '@sso/signup' }],
                          },
                          {
                              type: 'route',
                              path: 'domain-enrollment',
                              routes: [{ type: 'application', name: '@sso/signup' }],
                          },
                      ]
                    : []),
                {
                    type: 'route',
                    path: 'password',
                    routes: [{ type: 'application', name: '@sso/password-recovery' }],
                },
                {
                    type: 'route',
                    default: true,
                    routes: [{ type: 'application', name: '@sso/signin' }],
                },
            ],
        },
        {
            type: 'footer',
            routes: [{ type: 'application', name: '@sso/footer' }],
        },
    ],
});

const applications = constructApplications({
    routes,
    loadApp({ name }) {
        return System.import(name);
    },
});

const layoutEngine = constructLayoutEngine({
    routes,
    applications,
    active: false,
});

applications.forEach(registerApplication);
layoutEngine.activate();
start();

if (process.env.NODE_ENV === 'development') {
    /**
     * This handler will try to fall back to a deployed version of failed MFE.
     * This is handy if you're developing only one MFE and don't need to start others locally.
     */
    addErrorHandler(mfFallbackHandler);
}
